// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-input-container {
  width: 100%;
  border-top: 1px solid rgb(220, 220, 220);
  display: flex;
  flex-direction: column;
  background-color: white;
}

.message-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.message-input-file-input {
  display: none;
}

.message-input-attachment-button {
  height: 18px;
  width: 18px;
  top: 30px;
  left: 20px;
  position: absolute;
  border-radius: 50%;
  border: none;
  background-color: rgb(151, 151, 151);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.message-input-attachment-button:disabled {
  background-color: lightgray;
  cursor: not-allowed;
}

.message-input-attachment-button span {
  position: relative;
  width: 11px;
  height: 11px;
  transform: translateY(0px);
  flex-shrink: 0; /* Prevent flex container from shrinking the span */
}

.message-input-attachment-button span::before,
.message-input-attachment-button span::after {
  content: '';
  position: absolute;
  background-color: white;
}

.message-input-attachment-button span::before {
  width: 11px;
  height: 1px;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.message-input-attachment-button span::after {
  width: 1px;
  height: 11px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.message-input {
  border: none;
  outline: none;
  box-sizing: border-box;
  height: 77px;
  width: 100%;
  line-height: 17px;
  padding: 30.5px 58px;
  font-size: 14px;
  overflow-y: hidden;
  resize: none;
  font-family: Roboto, sans-serif;
  flex-shrink: 0;
  padding-right: 98px; /* Make room for send button */
}

.message-send-button {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.message-send-button:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.05);
}

.message-send-button:disabled {
  background: transparent;
  cursor: not-allowed;
}

.message-send-button i {
  color: rgb(71, 71, 71);
  font-size: 20px;
}

.message-send-button:disabled i {
  color: rgb(180, 180, 180);
}

/* Styles for attachment reply preview */
.compose-reply-preview.attachment-reply {
  display: flex;
  align-items: center;
  gap: 10px;
}

.attachment-reply-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  padding-left: 10px;
}

.compose-reply-preview.attachment-reply .attachment-fileinfo {
  font-weight: normal;
  font-style: normal;
  color: black;
}

.attachment-reply-thumbnail {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: 4px;
  padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/MessageInput.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,cAAc,EAAE,mDAAmD;AACrE;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,QAAQ;EACR,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,MAAM;EACN,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".message-input-container {\n  width: 100%;\n  border-top: 1px solid rgb(220, 220, 220);\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n}\n\n.message-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.message-input-file-input {\n  display: none;\n}\n\n.message-input-attachment-button {\n  height: 18px;\n  width: 18px;\n  top: 30px;\n  left: 20px;\n  position: absolute;\n  border-radius: 50%;\n  border: none;\n  background-color: rgb(151, 151, 151);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.message-input-attachment-button:disabled {\n  background-color: lightgray;\n  cursor: not-allowed;\n}\n\n.message-input-attachment-button span {\n  position: relative;\n  width: 11px;\n  height: 11px;\n  transform: translateY(0px);\n  flex-shrink: 0; /* Prevent flex container from shrinking the span */\n}\n\n.message-input-attachment-button span::before,\n.message-input-attachment-button span::after {\n  content: '';\n  position: absolute;\n  background-color: white;\n}\n\n.message-input-attachment-button span::before {\n  width: 11px;\n  height: 1px;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n}\n\n.message-input-attachment-button span::after {\n  width: 1px;\n  height: 11px;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.message-input {\n  border: none;\n  outline: none;\n  box-sizing: border-box;\n  height: 77px;\n  width: 100%;\n  line-height: 17px;\n  padding: 30.5px 58px;\n  font-size: 14px;\n  overflow-y: hidden;\n  resize: none;\n  font-family: Roboto, sans-serif;\n  flex-shrink: 0;\n  padding-right: 98px; /* Make room for send button */\n}\n\n.message-send-button {\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.message-send-button:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.message-send-button:disabled {\n  background: transparent;\n  cursor: not-allowed;\n}\n\n.message-send-button i {\n  color: rgb(71, 71, 71);\n  font-size: 20px;\n}\n\n.message-send-button:disabled i {\n  color: rgb(180, 180, 180);\n}\n\n/* Styles for attachment reply preview */\n.compose-reply-preview.attachment-reply {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.attachment-reply-icon {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  padding-left: 10px;\n}\n\n.compose-reply-preview.attachment-reply .attachment-fileinfo {\n  font-weight: normal;\n  font-style: normal;\n  color: black;\n}\n\n.attachment-reply-thumbnail {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  object-fit: cover;\n  border-radius: 4px;\n  padding-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
